"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PromoCardState_1 = require("./PromoCardState");
var localStyles = require("./PromoCard.scss");
var icons = require("../../../../styles/ccc-icons-cart.scss");
var styles = require("../../../CartConfigurationContainer/CartConfiguration.scss");
var Api_1 = require("../../../../api/Api");
var ui_components_1 = require("@idp/ui-components");
var components_1 = require("@idp/duc/components");
var utils_1 = require("@idp/ui-components/utils");
var TextFieldProps_1 = require("@idp/duc/components/atoms/TextField/TextFieldProps");
var ButtonProps_1 = require("@idp/ui-components/components/atoms/Button/ButtonProps");
var StateProvider_1 = require("../../../../api/StateProvider");
var ReportingService_1 = require("../../../../api/ReportingService");
var cms_integration_1 = require("@idp/cms-integration");
var LabelProps_1 = require("@idp/ui-components/components/atoms/Label/LabelProps");
var Cart_cms_1 = require("../../../../cms/Cart.cms");
var Utils = require("../../../../utils/UtilityFunctions");
var CartUtilFunctions_1 = require("../../../../utils/CartUtilFunctions");
var wlsUtils = require("../../../../utils/WirelessUtilFunctions");
var localdatastore_1 = require("../../../../config/localdatastore");
var PromoCard = /** @class */ (function (_super) {
    __extends(PromoCard, _super);
    function PromoCard(props) {
        var _this = _super.call(this, props) || this;
        _this.lobType = Utils.getCurrentLOBList();
        _this.isBundleCart = Utils.isBundleinCart().isBundleWithoutDTVNorAccessory;
        _this.campaignCouponCodeApplied = false;
        _this.couponCode = '';
        _this.api = new Api_1.default();
        _this.initializeEvents();
        _this.state = new PromoCardState_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.showRepCode = _this.showRepCode.bind(_this);
        _this.togglePromoCodeSection = _this.togglePromoCodeSection.bind(_this);
        return _this;
    }
    PromoCard.prototype.componentDidMount = function () {
        var _a, _b;
        var cookieVal = Utils.getCookie('sourceCode');
        var campaignCoupons = this.campaignCouponCmsData;
        if (campaignCoupons && cookieVal) {
            for (var _i = 0, _c = campaignCoupons.campaignOffers; _i < _c.length; _i++) {
                var offer = _c[_i];
                if (offer && offer.campaignId === cookieVal) {
                    this.couponCode = offer.couponId;
                    break;
                }
            }
        }
        var wlsCMS = wlsUtils.getWlsCmsData();
        this.customerCampaignBenefitDetail = wlsCMS.customerCampaignBenefitDetail
            || "Be sure to apply promo code <span> {0} </span> to get a discount on your eligible items!";
        this.customerCampaignBenefitDetail =
            this.customerCampaignBenefitDetail.replace('{0}', (this.couponCode));
        var payload = Utils.getCartResp();
        this.promotionArr = [];
        this.lobType = Utils.getCurrentLOBList() || undefined;
        if (payload) {
            var couponCodeArr = [];
            if ((_a = payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.promotions) {
                couponCodeArr = payload.wirelessCart.promotions;
                this.setState({ currentLobType: 'WIRELESS' });
            }
            else if ((_b = payload.broadbandCart) === null || _b === void 0 ? void 0 : _b.promotions) {
                couponCodeArr = payload.broadbandCart.promotions;
                this.setState({ currentLobType: 'BROADBAND' });
            }
            this.promotionArr = couponCodeArr.filter(function (promotion) {
                if (promotion.couponCode) {
                    return true;
                }
                return false;
            });
            if (payload.broadbandCart &&
                payload.broadbandCart.repCode) {
                this.repCodeValue = payload.broadbandCart.repCode;
                this.setState({
                    currentLobType: 'BROADBAND',
                    isRepCodeAvailable: true,
                    repCode: this.repCodeValue,
                });
            }
            if (payload && payload.metadata &&
                payload.metadata.metadata) {
                this.setState({
                    displayPromoCode: payload.metadata.metadata.couponFlag,
                    displayRepCode: payload.metadata.metadata.repCodeFlag,
                });
            }
        }
        if (this.promotionArr.length > 0 || this.repCodeValue ||
            (this.props && this.props.options && this.props.options.autoExpandPromoSection)) {
            this.setState({ displayGotPromoLink: false });
        }
        if (this.props.data && this.props.data.autoApplyCouponCode) {
            this.handleAutoCouponApply(this.props.data.autoApplyCouponCode);
        }
        var focusObject = this.stateManager.get(localdatastore_1.getNamespace('CART'), 'focusOnPromoSection');
        if (focusObject && focusObject.focus) {
            this.focusOnPromoSection();
            this.stateManager.remove('focusOnPromoSection');
        }
        if (this.couponCode) {
            this.setState({ promoToggleOpen: true });
        }
        else {
            this.setState({ promoToggleOpen: false });
        }
    };
    PromoCard.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.options.autoExpandPromoSection) {
            this.setState({ displayGotPromoLink: false });
        }
    };
    PromoCard.prototype.componentDidUpdate = function (prevProps) {
        if (this.props && this.props.data && this.props.data.autoApplyCouponCode &&
            (!(prevProps && prevProps.data && prevProps.data.autoApplyCouponCode) ||
                (this.props.data.autoApplyCouponCode.couponCode !== prevProps.data.autoApplyCouponCode.couponCode))) {
            this.handleAutoCouponApply(this.props.data.autoApplyCouponCode);
        }
    };
    PromoCard.prototype.render = function () {
        var _this = this;
        var _a, _b;
        this.promoCardTexts = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content.common.promoCart;
        this.campaignCouponCmsData = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content.common
            .campaignCoupons;
        this.applyPromoApiErrMsg = this.promoCardTexts.apiErrTxt;
        this.applyRepApiErrMsg = this.promoCardTexts.apiErrTxt;
        var promoErrClass = [localStyles.enterPromoCode, this.state.isPromoError ? styles.showErrMsg : ''];
        var gotAPromoLink = this.promoCardTexts.promoLinkLabel;
        if (this.state.displayPromoCode && this.state.displayRepCode) {
            gotAPromoLink = this.promoCardTexts.promoRepLinkLabel;
        }
        else if (this.state.displayPromoCode) {
            gotAPromoLink = this.promoCardTexts.promoLinkLabel;
        }
        else if (this.state.displayRepCode) {
            gotAPromoLink = this.promoCardTexts.repLinkLabel;
        }
        var payload = Utils.getCartResp();
        var couponPromoArr = [];
        if (payload) {
            couponPromoArr = ((_a = payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.promotions) || ((_b = payload.broadbandCart) === null || _b === void 0 ? void 0 : _b.promotions);
        }
        if (couponPromoArr != null && couponPromoArr.length > 0) {
            this.promotionArr = couponPromoArr.filter(function (promotion) {
                if (promotion.couponCode) {
                    if (_this.couponCode === promotion.couponCode) {
                        _this.campaignCouponCodeApplied = true;
                    }
                    return true;
                }
                return false;
            });
        }
        return (React.createElement("div", { className: localStyles.container },
            React.createElement("div", null,
                React.createElement("div", { className: localStyles.gotPromoCode },
                    React.createElement("div", { className: localStyles.title },
                        React.createElement("h2", { className: localStyles.titleText },
                            " ",
                            gotAPromoLink,
                            " ")),
                    React.createElement("div", { className: localStyles.promoCodeArrowContainer },
                        React.createElement(components_1.Link, { "aria-label": this.state.promoToggleOpen ? 'Collapse Promo Panel Section' : 'Expand Promo Panel Section', kind: "withPrependIcon", testId: utils_1.default('Cart', 'gotPromoCode'), 
                            // tslint:disable-next-line: jsx-no-lambda
                            className: styles.rennyCommonLink, onClick: this.togglePromoCodeSection, icon: (this.state.promoToggleOpen ?
                                React.createElement(components_1.IconSvg, { ariaLabel: "Promo Code UP arrow", size: 16, svgNodeStr: Utils.GET_ICON_SVG.UP }) :
                                React.createElement(components_1.IconSvg, { ariaLabel: "Promo Code DOWN arrow", size: 16, svgNodeStr: Utils.GET_ICON_SVG.DOWN })) }))),
                React.createElement("div", { style: { clear: 'both' } })),
            this.state.promoToggleOpen &&
                React.createElement("div", { className: localStyles.promoContentSection },
                    this.state.displayPromoCode &&
                        React.createElement("div", { id: "promoSection", className: promoErrClass.join(' ') },
                            !this.campaignCouponCodeApplied &&
                                !this.state.couponCodeApplied &&
                                this.couponCode &&
                                React.createElement("div", { className: localStyles.coupnCodeReminderMsg, dangerouslySetInnerHTML: { __html: this.customerCampaignBenefitDetail } }),
                            React.createElement("div", { className: localStyles.label },
                                React.createElement(ui_components_1.Label, { testId: utils_1.default('Label', 'enterPromoCode'), data: { text: this.promoCardTexts.enterPromoCodeLabel }, options: {
                                        className: (this.props.options && this.props.options.isExpressUp) ?
                                            localStyles.expupgotPromoCode : '',
                                    } })),
                            React.createElement("div", { id: "promoEntry", className: [styles.posRel, localStyles.promoinput].join(' ') },
                                React.createElement(components_1.TextField, { data: { input: this.state.promoCode }, testId: utils_1.default('TextField', 'promoCode'), "aria-label": "TextField promoCode", options: {
                                        accessibility: this.promoCardTexts.enterPromoCodeLabel,
                                        maxLength: 50, type: TextFieldProps_1.TextFieldType.TEXT,
                                    }, events: this.promoEntryEvents }),
                                React.createElement(ui_components_1.Button, { data: {
                                        disabled: this.state.isApplyBtnDisabled,
                                        text: this.promoCardTexts.applyCtaLabel,
                                    }, events: {
                                        onClick: function () {
                                            _this.applyPromoCode(_this.state.promoCode, _this.promoCardTexts.applyCtaLabel);
                                        },
                                    }, testId: utils_1.default('Button', 'applyPromoCode'), "aria-label": "Button applyPromoCode", options: { type: ButtonProps_1.ButtonType.SQUARE } }),
                                React.createElement("div", { className: this.state.isHardwareExists ? styles.dispErrMsg : styles.errTxt },
                                    React.createElement("i", { className: [icons.cccIconCart, icons.cccIconCartBadgealert].join(' '), role: "img", "aria-label": "Error", tabIndex: 0 }),
                                    React.createElement("span", { "aria-live": "assertive", role: "alert" }, this.state.promoErrTxt)),
                                React.createElement("div", { style: { clear: 'both' } }))),
                    (this.state.displayRepCode || this.state.isRepCodeAvailable) && this.showRepCode())));
    };
    PromoCard.prototype.initializeEvents = function () {
        var _this = this;
        this.promoEntryEvents = {
            onBlur: function (value) {
                if (value.length > 0) {
                    value = value.trim();
                    if (value.length > 2) {
                        _this.setState({ isApplyBtnDisabled: false });
                    }
                    else {
                        _this.setState({ isApplyBtnDisabled: true });
                    }
                }
            },
            onChange: function (event) {
                if (event.currentTarget.value.trim().length > 2) {
                    _this.setState({
                        isApplyBtnDisabled: false, isHardwareExists: false, isPromoError: false,
                        promoCode: event.currentTarget.value, promoErrTxt: '',
                    });
                }
                else {
                    _this.setState({
                        isApplyBtnDisabled: true, isHardwareExists: false, isPromoError: false,
                        promoCode: event.currentTarget.value, promoErrTxt: '',
                    });
                }
            },
            onClear: function (value, event) {
                _this.setState({
                    isApplyBtnDisabled: true,
                    isHardwareExists: false,
                    isPromoError: false,
                    promoCode: '',
                    promoErrTxt: '',
                });
            },
            onKeyPress: function (value, e) {
                value = value.trim();
                if (value.length > 1) {
                    if (e.keyCode !== 32) {
                        _this.setState({ isApplyBtnDisabled: false });
                    }
                }
                else {
                    _this.setState({ isApplyBtnDisabled: true });
                }
            },
        };
        this.repEntryEvents = {
            onBlur: function (value) {
                if (value.length > 1) {
                    value = value.trim();
                    if (value.length > 2) {
                        _this.setState({ isApplyRepBtnDisabled: false });
                    }
                    else {
                        _this.setState({ isApplyRepBtnDisabled: true });
                    }
                }
            },
            onChange: function (event) {
                if (event.currentTarget.value.trim().length > 2) {
                    _this.setState({
                        isApplyRepBtnDisabled: false, isRepError: false, isRepErrorRemove: false,
                        isRepHardwareExists: false,
                        repCode: Utils.removeSpecialChars(event.currentTarget.value), repErrTxt: '',
                    });
                }
                else {
                    _this.setState({
                        isApplyRepBtnDisabled: true, isRepError: false, isRepErrorRemove: false,
                        isRepHardwareExists: false,
                        repCode: Utils.removeSpecialChars(event.currentTarget.value), repErrTxt: '',
                    });
                }
            },
            onClear: function (value, event) {
                _this.setState({
                    isApplyRepBtnDisabled: true,
                    isRepError: false,
                    repCode: '',
                    repErrTxt: '',
                });
            },
        };
        this.handleAutoCouponApply = this.handleAutoCouponApply.bind(this);
    };
    PromoCard.prototype.applyPromoCode = function (promoCode, btnText, displayName, legaltext, rewardsDetails, rewardsamt) {
        var _this = this;
        this.props.events.doLoading(true);
        this.setState({ isHardwareExists: false, promoErrTxt: '', isPromoError: false });
        var couponDetailsObject;
        var couponaction = '';
        var couponcodes = this.promoCardTexts.couponCodesList;
        var couponcodelist = couponcodes && couponcodes.split(',');
        var payload = Utils.getCartResp();
        if (displayName && legaltext && rewardsDetails && rewardsamt) {
            couponDetailsObject = this.lobType.map(function (lobItem) {
                couponaction = _this.getCouponChecks(lobItem, promoCode, couponcodelist);
                return ({
                    action: 'ADD',
                    couponAction: couponaction,
                    couponCode: promoCode,
                    couponSequence: '1',
                    displayName: displayName,
                    legalDescription: legaltext,
                    lobType: lobItem,
                    redeemrewardDescription: rewardsDetails,
                    rewardAmount: rewardsamt,
                });
            });
        }
        else {
            couponDetailsObject = this.lobType.map(function (lobItem) {
                couponaction = _this.getCouponChecks(lobItem, promoCode, couponcodelist);
                return ({
                    action: 'ADD',
                    couponAction: couponaction,
                    couponCode: promoCode,
                    couponSequence: '1',
                    lobType: lobItem,
                });
            });
        }
        couponDetailsObject.forEach(function (couponObject) {
            if (payload && !payload.enablecouponcheck) {
                delete couponObject.couponAction;
            }
        });
        var promoCodeReqObj = {
            couponDetails: couponDetailsObject,
        };
        this.reportingService.firePromoCodeSubmitEvent(promoCode, false, '-2', ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, true, btnText, undefined);
        if (displayName && legaltext && rewardsDetails && rewardsamt) {
            this.handlePromoCodeApi(promoCodeReqObj, promoCode, btnText, true);
        }
        else {
            this.handlePromoCodeApi(promoCodeReqObj, promoCode, btnText, false);
        }
    };
    PromoCard.prototype.getCouponChecks = function (lobItem, promocode, couponcodelist) {
        var couponaction = '';
        if (lobItem && promocode && couponcodelist.length > 0 &&
            lobItem === 'WIRELESS' && couponcodelist.indexOf(promocode) > -1) {
            couponaction = 'EXISTING_WIRELINE';
        }
        return couponaction;
    };
    PromoCard.prototype.showRepCode = function () {
        var _this = this;
        var promoErrClass = [localStyles.margin15px, localStyles.enterPromoCode];
        return (React.createElement("div", { className: localStyles.margin15px },
            !this.state.isRepCodeAvailable &&
                React.createElement("div", { id: "repSection", className: promoErrClass.join(' ') },
                    React.createElement(ui_components_1.Label, { testId: utils_1.default('Label', 'enterRepCode'), data: { text: this.promoCardTexts.enterRepCodeLabel } },
                        React.createElement(components_1.Tooltip, { content: React.createElement("span", { dangerouslySetInnerHTML: {
                                    __html: this.promoCardTexts.repCodeTooltip,
                                } }), testId: utils_1.default('Tooltip', 'repCode_Tooltip'), className: styles.ducTooltip, position: "top", boxWidth: 300, offset: 75, zIndex: true },
                            React.createElement(components_1.IconSvg, { size: 16, colorClass: "color-ui-black", svgNodeStr: Utils.GET_ICON_SVG.QUESTION }))),
                    React.createElement("div", null,
                        React.createElement("div", { id: "repEntry", className: [styles.posRel, localStyles.promoinput].join(' ') },
                            React.createElement(components_1.TextField, { data: { input: this.state.repCode }, testId: utils_1.default('TextField', 'repCode'), options: {
                                    accessibility: this.promoCardTexts.enterRepCodeLabel,
                                    maxLength: 6, type: TextFieldProps_1.TextFieldType.TEXT,
                                }, events: this.repEntryEvents }),
                            React.createElement(ui_components_1.Button, { data: {
                                    disabled: this.state.isApplyRepBtnDisabled,
                                    text: this.promoCardTexts.applyRepCtaLabel,
                                }, events: {
                                    onClick: function () {
                                        _this.applyRepCode(_this.state.repCode, 'ADD', _this.promoCardTexts.applyRepCtaLabel);
                                    },
                                }, testId: utils_1.default('Button', 'applyRepCode'), options: { type: ButtonProps_1.ButtonType.SQUARE } })),
                        React.createElement("div", { className: this.state.isRepError ? styles.dispErrMsg : styles.errTxt },
                            React.createElement("i", { className: [icons.cccIconCart, icons.cccIconCartBadgealert].join(' '), role: "img", "aria-label": "Error", tabIndex: 0 }),
                            React.createElement("span", { "aria-live": "assertive", role: "alert" }, this.state.repErrTxt)),
                        React.createElement("div", { style: { clear: 'both' } }))),
            this.state.isRepCodeAvailable &&
                React.createElement("div", { className: promoErrClass.join(' ') },
                    this.state.isRepErrorRemove && this.repErrorMsg(),
                    React.createElement("div", null,
                        React.createElement("p", null, this.promoCardTexts.repCodeAppliedLabel),
                        React.createElement("div", { style: { marginTop: '3px', float: 'left' } },
                            React.createElement("span", null,
                                "\u00A0",
                                this.state.repCode)),
                        React.createElement("div", { className: localStyles.removeLink },
                            React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Link', 'repRemove_Link'), onClick: this.applyRepCode.bind(this, this.state.repCode, 'REMOVE', this.promoCardTexts.removeLinkLabel), className: styles.commonLinkSmall }, this.promoCardTexts.removeLinkLabel)),
                        React.createElement("div", { style: { clear: 'both' } })))));
    };
    PromoCard.prototype.applyRepCode = function (repCode, userAction, btnText) {
        var _this = this;
        this.props.events.doLoading(true);
        // Analytics Code: link click for verify action on address form button click
        this.reportingService.fireLinkClickEvent(btnText, ReportingService_1.PageUrls.CART_PAGE);
        this.setState({ isRepHardwareExists: false, repErrTxt: '', isRepError: false, isRepErrorRemove: false });
        var repCodeReqObj = {
            action: userAction,
            salesRepCode: this.state.repCode || '',
        };
        this.reportingService.fireRepCodeSubmitOrRemoveEvent(repCode, false, '-2', ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, userAction === 'ADD', btnText, undefined);
        this.api.applyRepCode(repCodeReqObj).then(function (response) {
            if (response && response.content) {
                _this.stateManager.set('cartUpdate', { cartRefresh: true });
                _this.stateManager.set('deviceUpdate', { deviceConfigRefresh: true });
                if (userAction === 'ADD') {
                    _this.setState({ isApplyRepBtnDisabled: true, isRepCodeAvailable: true });
                }
                else {
                    _this.setState({ isApplyRepBtnDisabled: true, repCode: null, isRepCodeAvailable: false });
                }
                _this.reportingService.fireRepCodeSubmitOrRemoveEvent(repCode, false, '0', ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, userAction === 'ADD', btnText, undefined);
            }
            else {
                if (response && response.error) {
                    var errorMsg = '';
                    if (userAction === 'ADD') {
                        errorMsg = String(_this.promoCardTexts.apiRepCodeAddErrTxt);
                        _this.setState({ isRepError: true, isRepErrorRemove: false, repErrTxt: errorMsg });
                    }
                    else {
                        errorMsg = String(_this.promoCardTexts.apiRepCodeRemoveErrTxt);
                        _this.setState({ isRepError: false, isRepErrorRemove: true, repErrTxt: errorMsg });
                    }
                    _this.reportingService.fireRepCodeSubmitOrRemoveEvent(repCode, true, response.error.errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, userAction === 'ADD', btnText, errorMsg);
                }
            }
            _this.props.events.doLoading(false);
            _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
        })
            .catch(function (err) {
            var message = String((userAction === 'ADD') ? _this.promoCardTexts.apiRepCodeAddErrTxt
                : _this.promoCardTexts.apiRepCodeRemoveErrTxt);
            _this.props.events.doLoading(false);
            _this.props.events.displayPanelError(true, {
                errorId: '',
                message: message,
            });
            _this.reportingService.fireRepCodeSubmitOrRemoveEvent(repCode, true, err && err.errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, userAction === 'ADD', btnText, message);
        });
    };
    PromoCard.prototype.repErrorMsg = function () {
        return (React.createElement("div", null,
            React.createElement(components_1.Alert, { closeable: false, onWhite: true, testId: utils_1.default('Cart', 'repCodeRemove', '_msg'), type: "error" },
                React.createElement(ui_components_1.Label, { data: { text: this.promoCardTexts.apiRepCodeRemoveErrTxt }, options: { className: localStyles.reperrormsg, size: LabelProps_1.LabelSizes.MEDIUM } }))));
    };
    PromoCard.prototype.handleAutoCouponApply = function (couponObj) {
        var sessionCoupon = this.stateManager.get(localdatastore_1.getNamespace('CART'), 'autoAppliedCoupon');
        if (couponObj && couponObj.couponCode &&
            (!sessionCoupon || couponObj.couponCode !== sessionCoupon.couponCode)) {
            this.setState({ promoCode: couponObj.couponCode, isApplyBtnDisabled: false });
            if (couponObj && couponObj.focusOnPanel) {
                this.stateManager.set('focusOnPromoSection', { focus: true });
            }
            this.applyPromoCode(couponObj.couponCode, couponObj.source, couponObj.displayName, couponObj.legaltext, couponObj.rewardsDetails, couponObj.rewardsamt);
            this.stateManager.set('autoAppliedCoupon', { couponCode: couponObj.couponCode, source: couponObj.source });
            if (couponObj && couponObj.focusOnPanel) {
                this.focusOnPromoSection();
            }
        }
    };
    PromoCard.prototype.focusOnPromoSection = function () {
        var promoSavingsElement = document.querySelector('[data-test-id=Message_Cart_MySaving]');
        setTimeout(function () {
            if (promoSavingsElement) {
                promoSavingsElement.scrollIntoView({ behavior: 'smooth' });
            }
        }, 2000);
    };
    PromoCard.prototype.handlePromoCodeApi = function (promoCodeReqObj, promoCode, btnText, isWireless) {
        var _this = this;
        this.api.applyPromoCode(promoCodeReqObj, isWireless).then(function (response) {
            if (response && response.content) {
                _this.stateManager.set('cartUpdate', { cartRefresh: true });
                _this.stateManager.set('deviceUpdate', { deviceConfigRefresh: true });
                _this.setState({ isApplyBtnDisabled: true, promoCode: '' });
                _this.reportingService.firePromoCodeSubmitEvent(promoCode, false, '0', ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, true, btnText, undefined);
                _this.setState({ promoToggleOpen: true, couponCodeApplied: true });
            }
            else if (response && response.error && response.error.message) {
                var errorTxt = response.error.message;
                if (response.error.errorId && response.error.errorId === 'Cart-U-1027') {
                    errorTxt = _this.promoCardTexts.promoCodeCheckErrorTxt;
                }
                _this.setState({
                    couponCodeApplied: false,
                    displayGotPromoLink: false,
                    displayPromoCode: true,
                    isPromoError: true,
                    promoErrTxt: errorTxt,
                    promoToggleOpen: true,
                });
                _this.reportingService.firePromoCodeSubmitEvent(promoCode, true, response.error.errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, true, btnText, response.error.message);
                _this.stateManager.remove('focusOnPromoSection');
            }
            _this.props.events.doLoading(false);
        }).catch(function (err) {
            _this.stateManager.remove('focusOnPromoSection');
            var msg = _this.applyPromoApiErrMsg;
            _this.props.events.doLoading(false);
            _this.props.events.displayPanelError(true, { errorId: '', message: msg });
            _this.reportingService.firePromoCodeSubmitEvent(promoCode, true, err && err.errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, true, btnText, msg);
        });
    };
    PromoCard.prototype.togglePromoCodeSection = function () {
        var _this = this;
        this.setState({ promoToggleOpen: !this.state.promoToggleOpen }, function () {
            _this.reportingService.fireLinkClickEvent(_this.state.promoToggleOpen ?
                'promo toggle open' : 'promo toggle close', CartUtilFunctions_1.getLinkClickBasekUrl());
        });
    };
    return PromoCard;
}(React.Component));
exports.default = PromoCard;
//# sourceMappingURL=PromoCard.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/PromoPanel/PromoCard/PromoCard.js
// module id = 761
// module chunks = 8